import type { Mask, Options } from 'use-mask-input';

export const MASK_PRESETS = {
  cpf: '999.999.999-99',
  // CNPJ alfanumérico (RFB): 12 caracteres alfanuméricos nos primeiros campos
  // + 2 dígitos verificadores no final. `*` aceita letras e dígitos; `9` só
  // dígitos. CNPJ numérico legado continua válido (subset de alfanumérico).
  cnpj: '**.***.***/****-99',
  caepf: '999.999.999/999-99',
  // Campo que aceita CPF (11 díg.) OU CAEPF (14 díg.). O `use-mask-input`
  // suporta máscaras alternadas via array: a máscara ativa é escolhida pelo
  // tamanho do que o usuário digita. Um CPF é o ponto de entrada da consulta
  // que descobre os CAEPFs vinculados a ele.
  cpfCaepf: ['999.999.999-99', '999.999.999/999-99'],
  phone: '(99) 99999-9999',
  cep: '99999-999',
} as const satisfies Record<string, Mask>;

export type MaskPresetKey = keyof typeof MASK_PRESETS;

/**
 * Opções do Inputmask por preset. O CNPJ alfanumérico é sempre MAIÚSCULO
 * (`casing: 'upper'`): o que o usuário digita em minúsculas já entra no form
 * state normalizado, sem depender de `toUpperCase()` espalhado pelos
 * consumidores.
 */
export const MASK_PRESET_OPTIONS: Partial<Record<MaskPresetKey, Options>> = {
  cnpj: { casing: 'upper' },
};

/**
 * Resolve `mask` (preset ou máscara literal) para o par `[mask, options]`
 * esperado por `withMask(mask, options)`. Preset desconhecido → usa a string
 * como máscara literal (comportamento anterior).
 */
export function resolveMaskWithOptions(
  mask: Mask | MaskPresetKey
): [Mask, Options | undefined] {
  if (typeof mask === 'string' && mask in MASK_PRESETS) {
    const key = mask as MaskPresetKey;
    return [MASK_PRESETS[key], MASK_PRESET_OPTIONS[key]];
  }
  return [mask, undefined];
}
